import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services = () => {
  return (
    <div className="services-container">
      <header className="services-header">
        <h1>Our Service Tracks</h1>
        <p>Transparent pricing for strategic clarity.</p>
      </header>

      {/* Pricing Table */}
      <div className="table-wrapper">
        <table className="fees-table">
          <thead>
            <tr>
              <th>Service Type</th>
              <th>Online <br/><span className="sub-head">(Hourly)</span></th>
              <th>Offline <br/><span className="sub-head">(4hr Block)</span></th>
              <th>Offline <br/><span className="sub-head">(Full Day / 8hr)</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <strong>In-House Risk Support</strong>
                <br/><span className="sub-text">Contracts, Strategy & Compliance</span>
              </td>
              <td>₹2,000</td>
              <td>₹6,000</td>
              <td>₹10,000</td>
            </tr>
            <tr>
              <td>
                <strong>Litigation Support</strong>
                <br/><span className="sub-text">Dispute Management & Oversight</span>
              </td>
              <td>₹5,000</td>
              <td>₹15,000</td>
              <td>₹20,000</td>
            </tr>
          </tbody>
        </table>
        <p className="disclaimer">
          * Offline visits in Mumbai/Thane/Navi Mumbai. Travel expenses billed at actuals.
        </p>
      </div>

      {/* Service Details */}
      <div className="cards-wrapper">
        <div className="service-card">
          <h3>In-House Risk Support</h3>
          <p>
            Designed for prevention. We act as your external General Counsel to handle contracts, 
            vendor negotiations, and internal policy to stop legal fires before they start.
          </p>
          <Link to="/support" className="btn btn-outline full-width">Inquire Now</Link>
        </div>

        <div className="service-card">
          <h3>Litigation Support</h3>
          <p>
            Designed for resolution. When you are forced into a legal battle, we provide 
            strategic oversight, manage your advocates, and ensure your business interests remain the priority.
          </p>
          <Link to="/support" className="btn btn-outline full-width">Inquire Now</Link>
        </div>
      </div>
    </div>
  );
};

export default Services;